// Module
var code = `<div class="mln-mainbody flex-col">

    <div id="dimmer" class="dimmer"></div>

    <div class="" id="preloader" style="width:40px;height:40px;display:none;position:fixed;z-index:2000">
        <div class="wBall" id="wBall_1">
            <div class="wInnerBall">
            </div>
        </div>
        <div class="wBall" id="wBall_2">
            <div class="wInnerBall">
            </div>
        </div>
        <div class="wBall" id="wBall_3">
            <div class="wInnerBall">
            </div>
        </div>
        <div class="wBall" id="wBall_4">
            <div class="wInnerBall">
            </div>
        </div>
        <div class="wBall" id="wBall_5">
            <div class="wInnerBall">
            </div>
        </div>
    </div>

    <div class="sidebar flex-col" id="sidebar">
        <div class="sidebar_header flex-row flex-no-shrink">
            <button id="sidebar-close">
                <i class="fa fa-arrow-left"></i>
            </button>
            <div class="flex-item flex-col">
                <input id="sidebar-search" type="search" placeholder="buscar" class="search-box" autocomplete="off">
            </div>
        </div>
        <div class="mln-module-menu" id="header-left" role="navigation">
            <ul class="mln-app-tab flex-col" style="margin:0"></ul>
        </div>
        <div class="flex-row">
            <div class="flex-col menu-side-panel"></div>
            <div style="overflow:auto" class="menu-tree-area lightscroll flex-item">

            </div>
        </div>
        <div class="version" style="display: flex;flex-direction: row;">
            <div>Versão PDV:</div>
            <div class="versionOmnichannel"></div>
            <div style="width:10px"></div>
            <div>Versão ERP:</div>
            <div class="versionMillennium"></div>
        </div>
    </div>

    <!-- Fixed navbar -->
    <div class="mln-module-header shadow-around-sml flex-row flex-align-center" id="header" role="navigation">
        <!-- Logo Button -->
        <button class="navbar-brand flex-row flex-align-center" title="Menu de módulos" id="menu-btn">
            <!-- <i style="min-width:1em" class="fa fa-bars"></i>-->
            <!-- Logo -->
            <svg class="linx-brand__totvs-svg" viewBox="0 0 32.668 39.151" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path fill="currentColor" d="M31.8573 8.19423c-.2058-.7611-.6998-1.44361-1.3955-1.97307C26.8064 3.46631 22.4677 1.40224 17.742.177866 17.285.0579097 16.8116 0 16.3341 0s-.9509.0579097-1.4078.177866C10.2006 1.40224 5.85773 3.46631 2.21054 6.22116c-.69568.52533-1.18966 1.21197-1.39548 1.97307C.271687 10.1963 0 12.2355 0 14.2748v10.6016c0 2.0392.271687 4.0785.81506 6.0805.20582.7611.6998 1.4436 1.39548 1.9731 3.6513 2.7548 7.99416 4.8189 12.71576 6.0433.4569.1199.9303.1778 1.4078.1778s.9509-.0579 1.4079-.1778c4.7257-1.2244 9.0685-3.2885 12.7157-6.0433.6957-.5254 1.1897-1.212 1.3955-1.9731.5434-2.002.8151-4.0413.8151-6.0805V14.2748c0-2.0393-.2717-4.0785-.8151-6.08057zm-.4528 12.07007c-.1852.6783-.6175 1.2905-1.2596 1.7745-1.7907 1.3526-3.7666 2.5439-5.8742 3.5449-2.1077 1.001-4.3511 1.8117-6.6687 2.4157-.4116.1075-.8356.1613-1.2679.1613-.4322 0-.8562-.0538-1.2678-.1613-2.3176-.5998-4.5611-1.4147-6.66872-2.4157s-4.08353-2.1964-5.87419-3.5449c-.63805-.484-1.0744-1.0962-1.25964-1.7745-.12349-.455-.12349-.9349 0-1.3899.18524-.6783.61747-1.2905 1.25964-1.7745 1.79066-1.3526 3.76657-2.5439 5.87419-3.5449s4.35112-1.8117 6.66872-2.4156c.4116-.1076.8356-.1614 1.2678-.1614.4323 0 .8563.0538 1.2679.1614 2.3176.5997 4.561 1.4146 6.6687 2.4156 2.1076 1.001 4.0835 2.1965 5.8742 3.5449.638.484 1.0744 1.0962 1.2596 1.7745.1235.455.1235.9349 0 1.3899z">
                </path>
            </svg>
        </button>

        <div class="flex-col flex-item">
            <div class="menu-bar" hidden>
            </div>
            <div class="mln-app-header flex-row">

                <ul class="mln-app-tab flex-row flex-wrap">
                </ul>

                <div class="app-toolbar">
                    <button title="Adicionar aos favoritos" id="favorite_toggle_button" class="favorite-toggle-button">
                        <i class="far fa-star" style="display:block;font-size:150%"></i>
                    </button>
                    <button title="Aviso" id="notification_button" class="notification-button" hidden>
                        <div>
                            <i class="fa fa-bell" style="display:block;font-size:150%"></i>
                        </div>
                        <svg id="" style="position: absolute;bottom: 0;right: 0;width: 14px;height: 14px;">
                            <circle cx="7" cy="7" r="7" stroke="black" stroke-width="0" style="fill: var(--accent-color)">
                            </circle>
                            <text id="notification_count" x="7" y="11" fill="white" style="font-size: 8pt; width: 6px;" width="20" text-anchor="middle"></text>
                        </svg>
                    </button>
                    <button title="Avaliar / enviar feedback" id="feedback_button" class="feedback-button">
                        <svg viewBox="-40 -50 604 604" style="display:block;width:1.5em;height:1.5em;fill:currentColor" aria-hidden="true" focusable="false">
                            <g transform="translate(-30,150) scale(0.74)">
                                <path d="M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144z"/>
                            </g>
                            <g transform="translate(272,-26) scale(0.55)">
                                <path d="M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"/>
                            </g>
                        </svg>
                    </button>
                    <img id="usr-img" class="usr-img" width="28" height="28">
                </div>

            </div>
        </div>
    </div>

    <div class="notifications top-right" style="z-index:65000"></div>

    <div class="flex-row flex-item" style="height:100%;">
        <div class="side-module-selector" style="display:none">

        </div>

        <div id="content-frame" class="mln-main-frame">
        </div>

        <div id="login-div" class="flex-col" style="flex:1;display:none;cursor:default">

            <div class="flex-item flex-col flex-justify-center" style="max-width:15rem;margin:auto;padding:10px">
                <div class="login-container">
                    <mln-logo-image style="--logo-text-color:white;width:180px"></mln-logo-image>
                    <div id="login-message" style="font-size:130%;text-align:center;margin-bottom:10px"></div>
                    <!-- host -->
                    <div class="flex-row flex-align-center form-control mln-host-input" style="display:none;margin-bottom:10px;background: #00000014;padding:7.5px">
                        <span class="input-group-addon fa fa-cloud" style="background:none;border:none;padding:0px 5px 0px 0px"></span>
                        <input autocomplete="off" class="light-placeholder" id="hostname" type="url" placeholder="Servidor" style="border:none;background:none">
                    </div>
                    <!-- unlicensed message -->
                    <div id="login-unlicensed" style="display:none;text-align:center;margin-top:1em">
                        <span class="fa fa-exclamation-triangle" style="font-size:3em;color:#f0ad4e;display:block;margin-bottom:0.5em"></span>
                        <div style="font-size:120%;font-weight:bold;margin-bottom:0.5em">Servidor sem licenciamento
                        </div>
                        <div style="font-size:90%;opacity:0.8">Entre em contato com o suporte para ativar a licença
                            deste servidor.</div>
                    </div>
                    <!-- server error message -->
                    <div id="login-server-error" style="display:none;text-align:center;margin-top:1em">
                        <span class="fa fa-exclamation-circle" style="font-size:3em;color:#d9534f;display:block;margin-bottom:0.5em"></span>
                        <div style="font-size:120%;font-weight:bold;margin-bottom:0.5em">Erro interno no servidor</div>
                        <div style="font-size:90%;opacity:0.8">O servidor encontrou um erro ao processar a solicitação.
                            Tente novamente ou entre em contato com o suporte.</div>
                    </div>
                    <!-- login fields -->
                    <div id="login-fields">
                        <div>
                            <select name="" id="licence_type" style="background:#00000014;padding:5px;width:100%;border-color:silver"></select>
                        </div>
                        <!-- user -->
                        <div class="flex-row flex-align-center form-control" style="margin-top:0.5em;background: #00000014;padding:7.5px">
                            <span class="input-group-addon fa fa-user" style="background:none;border:none;padding:0px 5px 0px 0px;"></span>
                            <input autocomplete="off" class="light-placeholder" id="username" type="text" placeholder="Usuário" style="border:none;background:none;width:100%">
                        </div>
                        <!-- pass -->
                        <div class="flex-row flex-align-center form-control" id="pwd-group" style="margin-top:0.5em;background: #00000014;padding:7.5px">
                            <span class="input-group-addon fa fa-key" style="background:none;border:none;padding:0px 5px 0px 0px;"></span>
                        </div>
                        <div class="flex-row">
                            <button class="btn shadow-around-sml" id="login" style="width:100%;margin-top:1em">ENTRAR</button>
                            <button class="btn shadow-around-sml" id="login_cancel" style="display:none;width:100%;margin-top:1em;margin-left:10px;margin-right:0">CANCELAR</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>`;
// Exports
export default code;